import styled, { css } from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Cards from 'theme/components/Cards.style';
import * as Texts from 'theme/components/Text.style';
import * as Buttons from 'theme/components/Buttons.style';

export const Card = styled(Cards.BaseCard)`
  gap: 15px;
  box-shadow: none;
  @media (max-width: ${breakpoints.tablet}) {
    border-radius: 40px;
  }
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
`;

export const LabelIcon = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;

  svg {
    width: 18px;
    height: 18px;

    path {
      stroke: ${(props) => props.$color};
      stroke-width: 2;
    }
  }
`;

export const LabelText = styled(Texts.P1Semibold)<{ $color: string }>`
  color: ${(props) => props.$color};
  font-weight: 650;
  line-height: 16px;
`;

export const Title = styled(Texts.P2Semibold)`
  font-weight: 650;
  line-height: 20px;
  width: 100%;
`;

export const Body = styled(Texts.P2)`
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  width: 100%;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

export const ActionPill = styled(Buttons.SecondaryLight).attrs({
  $size: 'small' as const,
})<{ $isDisabled?: boolean }>`
  max-width: 230px;
  gap: 5px;
  padding: 10px 15px;
  border-radius: 20px;
  background-color: ${colours.neutral[200]};
  width: fit-content;
  flex-grow: 0;

  ${(props) =>
    props.$isDisabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: ${breakpoints.tablet}) {
    width: fit-content;
    flex-grow: 0;
  }
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const SourcesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SourcesLabel = styled(Texts.P1Semibold)`
  color: ${colours.neutral[500]};
  line-height: 16px;
`;

export const SourcesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const SourceItem = styled(Buttons.SecondaryLight).attrs({
  $size: 'small' as const,
})`
  max-width: 100%;
  gap: 5px;
  width: fit-content;
  flex-grow: 0;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

export const SourceText = styled(Texts.P2Semibold)<{
  $middleTruncate?: boolean;
}>`
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
  flex: 1 1 auto;
  ${(props) =>
    props.$middleTruncate
      ? css`
          display: flex;
          align-items: baseline;
        `
      : css`
          text-overflow: ellipsis;
        `}
`;

export const SourceTextStart = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 0 1 auto;
`;

export const SourceTextEnd = styled.span`
  flex: 0 0 auto;
  white-space: nowrap;
`;

export const MessageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const MessageLabel = styled(Texts.P1Semibold)`
  color: ${colours.neutral[500]};
`;

export const MessageBody = styled.div<{ $isExpanded: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${colours.neutral[100]};
  padding: 15px;
  border-radius: 28px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  max-height: ${(props) => (props.$isExpanded ? 'none' : '150px')};

  &:focus-visible {
    outline: 2px solid ${colours.blue[500]};
    outline-offset: 2px;
  }
`;

export const MessageBodyText = styled(Texts.P2)<{ $isExpanded: boolean }>`
  white-space: pre-wrap;
  overflow-wrap: anywhere;

  ${(props) =>
    !props.$isExpanded &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;
